/**@jsxImportSource theme-ui */
import React from 'react';
import Container from '../Container';
import FlexContainer from '../FlexContainer';
import { Icon, IconButton } from '../Icon';
import { Overlay, OverlayContent, OverlayControlProps } from '../Overlay';
import { AllCaroteneColors } from '../utils/types';
import { colors } from '../../tokens';

export interface ModalProps extends OverlayControlProps {
    showClose?: boolean;
    fullScreenMobile?: boolean;
    backgroundColor?: AllCaroteneColors;
    width?: string;
}
function ModalHeader({ children }: React.PropsWithChildren<unknown>): JSX.Element {
    return (
        <FlexContainer paddingLeftRight="25px" sx={{ paddingTop: '25px' }} justifyContent="flex-end">
            {children}
        </FlexContainer>
    );
}

function ModalCloseButton(props: React.HTMLAttributes<HTMLButtonElement>): JSX.Element {
    return (
        <ModalHeader>
            <IconButton aria-label="Close Modal" icon={<Icon size="18px" color="carrotOrange" name="x" />} {...props} />
        </ModalHeader>
    );
}

export function Modal({
    children,
    open,
    onClose,
    showClose,
    fullScreenMobile,
    isDismissable,
    backgroundColor,
    width,
}: React.PropsWithChildren<ModalProps>): JSX.Element {
    const overlayRef = React.useRef();

    return (
        <Overlay background="black30" open={open}>
            <OverlayContent
                sx={{
                    backgroundColor: backgroundColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    width,
                    overflow: 'auto',
                    '&::-webkit-scrollbar, -ms-overflow-style': {
                        display: 'none',
                    },
                }}
                as="aside"
                closeButton={showClose ? ModalCloseButton : null}
                maxWidth="600px"
                shadow="sheet"
                maxHeight="100vh"
                height={fullScreenMobile ? ['100vh', null, 'auto', 'auto'] : 'auto'}
                borderRadius={fullScreenMobile ? ['0', null, '8px', null] : '8px'}
                ref={overlayRef}
                open={open}
                onClose={onClose}
                isDismissable={isDismissable}
            >
                <Container>{children}</Container>
            </OverlayContent>
        </Overlay>
    );
}

Modal.defaultProps = {
    backgroundColor: colors.base.white,
    width: '100%',
};
